import { render, staticRenderFns } from "./OrmInformTotalLoss.vue?vue&type=template&id=5d35e97e"
import script from "./OrmInformTotalLoss.vue?vue&type=script&lang=js"
export * from "./OrmInformTotalLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports